export const appConfig = (window as any).APP_CONFIG ?? {};